import { render, staticRenderFns } from "./ApiResourceMgmt.vue?vue&type=template&id=42bef7ba&scoped=true"
import script from "./ApiResourceMgmt.vue?vue&type=script&lang=js"
export * from "./ApiResourceMgmt.vue?vue&type=script&lang=js"
import style0 from "./ApiResourceMgmt.vue?vue&type=style&index=0&id=42bef7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bef7ba",
  null
  
)

export default component.exports